import { render, staticRenderFns } from "./VircosFinishing.vue?vue&type=template&id=77881497&scoped=true&"
import script from "./VircosFinishing.vue?vue&type=script&lang=js&"
export * from "./VircosFinishing.vue?vue&type=script&lang=js&"
import style0 from "./VircosFinishing.vue?vue&type=style&index=0&id=77881497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77881497",
  null
  
)

export default component.exports